// extracted by mini-css-extract-plugin
export var wrapper = "color-panel-module--wrapper--ecf3a";